export default __webpack_public_path__ + "static/media/PK.4edcdce1.svg";